<template>
  <v-app class="app-ajustador background-personalizado-1">
    <img
      src="/fondo-regalo.jpg"
      class="background-personalizado-2"
    >
    <main style="display:flex; flex-direction:column; flex:1;">
      <notifications
        group="notificacion"
        animation-name="v-fade-left"
        position="bottom right"
        :duration="10000"
        :max="$vuetify.breakpoint.xsOnly ? 1 : 3"
      >
        <template
          slot="body"
          slot-scope="props"
        >
          <div :class="`${props.item.type} lighten-1 custom-template`">
            <div class="custom-template-content">
              <div class="custom-template-title white--text">
                <span
                  class="subheading font-weight-black"
                  style="text-decoration:underline"
                >{{ props.item.title }}</span>
              </div>
              <div
                class="body-1 font-weight-medium white--text"
                style="text-align: justify"
                v-html="props.item.text"
              />
            </div>
            <div
              class="custom-template-close"
              @click="props.close"
            >
              <v-icon>
                cancel
              </v-icon>
            </div>
          </div>
        </template>
      </notifications>
      <DialogProgress
        :titulo="GetdialogProgressLabel"
        :dialog="GetdialogProgress"
      />

      <template v-if="$store.state.sessionIciado">
        <v-navigation-drawer
          v-model="drawer"
          :clipped="clipped"
          enable-resize-watcher
          :mini-variant.sync="mini"
          fixed
          app
          dark
          width="340"
          class="vertical-gradient"
        >
          <AppMenu
            :mini="mini"
            @emitOpcionSeleccionada="onEmitOpcionSeleccionada()"
          >
            <template v-slot:SeccionFinal>
              <v-spacer />
              <v-list-tile
                v-if="['lg','xl','md'].includes($vuetify.breakpoint.name)"
                class="white--text"
                @click.stop="mini=!mini"
              >
                <v-list-tile-action>
                  <v-icon v-if="mini">
                    keyboard_double_arrow_right
                  </v-icon>
                  <v-icon v-if="!mini">
                    keyboard_double_arrow_left
                  </v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="body-2">
                  <em v-if="!mini">Replegar menú</em>
                </v-list-tile-title>
              </v-list-tile>
            </template>
          </AppMenu>
        </v-navigation-drawer>
      </template>

      <template>
        <v-toolbar
          v-if="$store.state.sessionIciado"
          dark
          fixed
          app
          class="elevation-0 horizontal-gradient"
          :clipped-left="clipped"
        >
          <v-toolbar-side-icon @click.stop="drawer = !drawer" />
          <section
            class="d-flex align-center clickable"
            @click="$router.push('/')"
          >
            <img
              style="object-fit:contain; border-radius: 8px;"
              width="90px"
              src="@/assets/logo-plataforma-aj-linea-blanco-negro-md.png"
            >
          </section>
          <v-spacer />
          <div class="d-flex align-center">
            <v-icon
              small
              class="hide-on-movile"
            >
              verified
            </v-icon>&nbsp;&nbsp;&nbsp;<span
              class="titulo-on-toolbar"
              :title="$store.state.datosSession.nombreCompleto"
            >{{ ($store.state.datosSession.nombreCompleto || '').length > 40 ? ($store.state.datosSession.nombreCompleto || '').slice(0, 40) + '...' : $store.state.datosSession.nombreCompleto }}</span>
          </div>
          <v-spacer />
          <v-btn
            :small="['sm','xs'].includes($vuetify.breakpoint.name)"
            icon
          >
            <img
              src="/iconos/icono-casa-blanco-negro-md.png"
              alt=""
              width="26px"
              class="hide-on-movile"
              @click="showDatosUsuario = false, $router.push('/')"
            >
          </v-btn>
          <v-menu
            offset-y
            :close-on-content-click="true"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                :small="['sm','xs'].includes($vuetify.breakpoint.name)"
                v-on="on"
              >
                <img
                  src="/iconos/icono-reloj-blanco-negro-md.png"
                  alt=""
                  width="26px"
                >
              </v-btn>
            </template>
            <Horarios />
          </v-menu>
          <v-menu
            offset-y
            :close-on-content-click="true"
            min-width="300px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                :small="['sm','xs'].includes($vuetify.breakpoint.name)"
                v-on="on"
              >
                <img
                  src="/iconos/icono-pregunta-blanco-negro-md.png"
                  alt=""
                  width="26px"
                >
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                class="oscuro--text"
                @click="verRegulatoria()"
              >
                <v-list-tile-title class="caption">
                  <strong>{{ 'Resolución Regulatoria'.toUpperCase() }}</strong>
                </v-list-tile-title>
                <v-list-tile-action class="justify-end">
                  <v-icon
                    color="secondary"
                  >
                    picture_as_pdf
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile
                class="oscuro--text"
                @click="verManualUsuario()"
              >
                <v-list-tile-title class="caption">
                  <strong>{{ 'Manual de usuario'.toUpperCase() }}</strong>
                </v-list-tile-title>
                <v-list-tile-action class="justify-end">
                  <v-icon
                    color="secondary"
                  >
                    picture_as_pdf
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>

              <v-divider />

              <v-list-tile
                class="oscuro--text"
                @click="whatsappWebRegional()"
              >
                <v-list-tile-title class="caption">
                  <strong>{{ 'Asesoramiento para el envio de solicitudes'.toUpperCase() }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
                </v-list-tile-title>
                <v-list-tile-action class="justify-end">
                  <IconWhatsapp
                    color="green"
                    :size="24"
                  />
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile
                class="oscuro--text"
                @click="whatsappWebSoporte()"
              >
                <v-list-tile-title class="caption">
                  <strong>{{ 'Soporte técnico en línea'.toUpperCase() }}</strong>
                </v-list-tile-title>
                <v-list-tile-action class="justify-end">
                  <IconWhatsapp
                    color="green"
                    :size="24"
                  />
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn
            :small="['sm','xs'].includes($vuetify.breakpoint.name)"
            icon
            @click="showDatosUsuario = !showDatosUsuario"
          >
            <img
              src="/iconos/icono-empresa-blanco-negro-md.png"
              alt=""
              width="26px"
            >
          </v-btn>
          <v-menu
            offset-y
            :close-on-content-click="false"
            min-width="300px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                :small="['sm','xs'].includes($vuetify.breakpoint.name)"
                icon
                v-on="on"
              >
                <v-icon :large="['lg','xl'].includes($vuetify.breakpoint.name)">
                  more_vert
                </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-subheader><v-icon>person</v-icon>&nbsp;&nbsp;&nbsp;{{ $store.state.datosSession.login }}</v-subheader>
              <v-divider />
              <v-list-tile
                v-for="(opcion, i) in opcionesAdmin.filter(i => i.menuParametrizadoPadreId != null)"
                :key="i"
                class="oscuro--text"
                @click="clickMenu(opcion.ruta)"
              >
                <v-list-tile-title class="caption">
                  <strong>{{ opcion.titulo.toUpperCase() }}</strong>
                </v-list-tile-title>
                <v-list-tile-action>
                  <v-icon
                    :color="`${opcion.color}`"
                    right
                    v-text="opcion.icono"
                  />
                </v-list-tile-action>
              </v-list-tile>
              <!-- <v-list-tile @click="cerrarSession()" class="error--text">
                <v-list-tile-title class="caption"><strong>CERRAR SESSIÓN</strong></v-list-tile-title>
                <v-list-tile-action>
                  <v-icon color="error" right>exit_to_app</v-icon>
                </v-list-tile-action>
              </v-list-tile> -->
            </v-list>
          </v-menu>
        </v-toolbar>
        <v-content
          class="responsive-ajustador-max-width"
          style="z-index: 1;"
        >
          <transition
            v-if="$store.state.sessionIciado"
            name="slide-y"
          >
            <DatosEmpresa
              v-show="showDatosUsuario"
              @emitCerrarDatosUsuario="showDatosUsuario = false"
            />
          </transition>
          <router-view v-show="!showDatosUsuario" />
        </v-content>
        <!-- <PdfVista
          :p-url-archivo-pdf="urlDocumentoResolucion"
          p-titulo="REGLAMENTO PARA OTORGAR AUTORIZACIONES DE PROMOCIONES EMPRESARIALES"
          :p-ver-modal.sync="verModalRegulatoria"
          @emitCerrarVistaPdf="verModalRegulatoria=false"
        /> -->
        <PdfVista
          p-url-archivo-pdf="/documents/doc_regulatoria_2_2.pdf"
          p-titulo="REGLAMENTO PARA OTORGAR AUTORIZACIONES DE PROMOCIONES EMPRESARIALES"
          :p-ver-modal.sync="verModalRegulatoria"
          @emitCerrarVistaPdf="verModalRegulatoria=false"
        />
        <PdfVista
          p-url-archivo-pdf="/documents/manual_usuario_sistema.pdf"
          p-titulo="MANUAL DE USUARIO"
          :p-ver-modal.sync="verModalManualUsuario"
          @emitCerrarVistaPdf="verModalManualUsuario=false"
        />
      </template>
    </main>
  </v-app>
</template>
<script>
import AppMenu from "@/components/shared/AppMenu";
import DatosEmpresa from "@/components/shared/DatosEmpresa";
import DialogProgress from "@/components/shared/DialogProgress";
import typesUtils from "@/store/types/utils";
import types from "@/store/types/Usuario";
import { mapActions, mapGetters } from "vuex";
import PdfVista from "@/components/PdfVista.vue";
import typesDocumentos from "@/store/types/Documentos";
import IconWhatsapp from "@/components/Icons/IconWhatsapp"
import Horarios from "./components/Horarios.vue";
import axios from  "axios";
export default {
  name: "App",
  components: {
    AppMenu,
    DatosEmpresa,
    DialogProgress,
    PdfVista,
    IconWhatsapp,
    Horarios,
  },
  data() {
    return {
      clipped: true,
      drawer: true,
      showDatosUsuario: false,
      opcionesAdmin: [],
      mini: false,
      verModalRegulatoria: false,
      verModalManualUsuario: false,
      urlDocumentoResolucion:'',
      messageWhatsapp: '',
      urlContactoWhatsappSoporte: `https://wa.me/${process.env.VUE_APP_NUMBER_WHATSAPP_SOPORTE}?text=`,
      whatsappDRLP: process.env.VUE_APP_NUMBER_WHATSAPP_DRLP,
      whatsappDRSC: process.env.VUE_APP_NUMBER_WHATSAPP_DRSC,
      whatsappDRCB: process.env.VUE_APP_NUMBER_WHATSAPP_DRCB,
    };
  },
  mounted() {
    if(this.$store.state.sessionIciado){
      this.obtenerUrlResolucion()
    }
  },
  beforeMount() {
    this.$store.commit('initialiseSession')
    this.obtenerBitacoraTotalCorreo()
  },
  methods: {
    async cerrarSession() {
        let datosSesion = localStorage.getItem('pObjDatosSession')

        try {

          if(datosSesion){
            datosSesion= JSON.parse(datosSesion)
                  const data= {
                      usuarioEmpresaId:datosSesion.usuarioEmpresaId,
                      usuarioId:datosSesion.usuarioId,
                      login:datosSesion.login,
                    }
                 await axios.post(`${process.env.VUE_APP_API_AJAYU}pajel/usuario_empresa/logout`,data,{headers: {
                      'application': 'WEB',
                      'subsystem': 'PAJEL',
                      'module': 'LOGOUT'
            }}).then(response => {console.log("registro de aceptación exitoso",response.data)})
          }
        } catch (error) {
          this.error = 'Hubo un error generar datos';
          console.error(error);
        } finally {
          localStorage.setItem("token", "");
          this.$store.commit("vaciarDatosSession");
          this.$router.push("/Login");
        }
    },

    CargarMenusAdministracion() {
      this.ObtenerListaMenus('0').then(respuesta => {
        const items = respuesta.data
        this.opcionesAdmin = items
      });
    },
    async obtenerBitacoraTotalCorreo() {
      await this.BitacoraTotalCorreo({usuarioId: this.$store.state.datosSession.usuarioEmpresaId});
    },
    ...mapActions({
      ObtenerListaMenus: types.actions.ObtenerListaMenus,
      UrlResolucion: typesDocumentos.actions.UrlResolucion,
      BitacoraTotalCorreo: types.actions.BitacoraTotalCorreo
    }),
    go(url) {
      this.$router.push(url);
    },
    clickMenu(value) {
      if(value.startsWith('/')) {
        this.go(value);
      } else {
        if(value == 'cerrarSession') {
          this.cerrarSession();
        }
      }
    },
    obtenerUrlResolucion(){
      this.UrlResolucion().then((res)=> {
        this.urlDocumentoResolucion = res.data.enlaceDocumento
      })
    },
    verRegulatoria() {
      this.verModalRegulatoria=true
    },
    verManualUsuario() {
      this.verModalManualUsuario=true
    },
    whatsappWebSoporte(){
      this.messageWhatsapp = `Hola, soy de la empresa ${this.$store.state.datosSession.nombreCompleto.trim()}, escribo para realizar la siguiente consulta:`
      window.open(this.urlContactoWhatsappSoporte + encodeURIComponent(this.messageWhatsapp), '_blank')
    },
    whatsappWebRegional(){
      this.messageWhatsapp = `Hola, soy de la empresa ${this.$store.state.datosSession.nombreCompleto.trim()}, escribo para realizar la siguiente consulta:`
      window.open(this.urlContactoWhatsappRegional + encodeURIComponent(this.messageWhatsapp), '_blank')
    },
    onEmitOpcionSeleccionada() {
      this.showDatosUsuario = false;
    }
  },
  computed: {
    ...mapGetters({
      GetdialogProgress: typesUtils.getters.GetdialogProgress,
      GetdialogProgressLabel: typesUtils.getters.GetdialogProgressLabel,
    }),
    urlContactoWhatsappRegional() {
      switch(this.$store.state.datosSession.oficinaId) {
        // DIRECCION REGIONAL LA PAZ
        case 1001:
          return `https://wa.me/${this.whatsappDRLP}?text=`
        // DIRECCION REGIONAL SANTA CRUZ
        case 1002:
          return `https://wa.me/${this.whatsappDRSC}?text=`
        // DIRECCION REGIONAL COCHABAMBA
        case 1003:
          return `https://wa.me/${this.whatsappDRCB}?text=`
      }
      return null
    }
  },
  watch: {
    $route(to, from) {
      this.showDatosUsuario = false;
    },
    '$store.state.sessionIciado': {
      handler: function (val) {
        if (val) {
          this.CargarMenusAdministracion(1);
        }
      },
      immediate: true
    },
  }
};
</script>
<style src="./global.css"></style>

